import { Box } from '@mui/material';
import styled from 'styled-components';

import { TContentBoxProps } from '@/shared/components/layouts/content-layout/content-layout.types';

export const ContentContainer = styled(Box).attrs({
  className: 'ContentContainer',
})`
  && {
    height: calc(100vh - 8rem);
    min-height: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    max-width: none;
    display: flex;
    justify-content: center;
  }
`;

export const ContentBox = styled(Box)<TContentBoxProps>`
  && {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(7)};
    width: 100%;
    height: 100%;
    min-height: 0;
    align-items: center;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
      max-width: 100%;
    }
  }
`;
